import quickInputModelSchema from './quick-input-model-schema.graphql';

export { quickInputModelSchema };
